module.exports = __webpack_public_path__ + "static/img/balance-nodata.03921e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/balance-nodata.png
// module id = Oo+o
// module chunks = 4